var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.964,
    height: 12.447,
    viewBox: "0 0 12.964 12.447",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13921",
    "data-name": "Group 13921",
    transform: "translate(-6775 -17418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44581",
    "data-name": "Path 44581",
    d: "M.007,6.376a1.726,1.726,0,0,1,0-.3c.078-.6.746-.945,1.139-1.306.221-.2.224-.2.169-.5-.11-.611-.493-1.221-.089-1.829.391-.588,1.124-.48,1.728-.525a1.242,1.242,0,0,0,.356-.074,5.2,5.2,0,0,0,.4-.964c.334-.752.863-1.1,1.673-.715.255.121.889.65,1.108.64S7.333.272,7.6.15A1.116,1.116,0,0,1,9.238.838a5.733,5.733,0,0,0,.42,1,1.242,1.242,0,0,0,.356.074c.6.044,1.326-.063,1.717.51a1.4,1.4,0,0,1,.1,1.21,3.3,3.3,0,0,0-.206.925c.038.125.619.519.754.639a1.194,1.194,0,0,1,0,2.055c-.135.12-.717.516-.754.639a6.494,6.494,0,0,0,.267,1.193c.163,1.055-.468,1.384-1.4,1.452-.183.013-.7-.028-.836.075a5.733,5.733,0,0,0-.42,1A1.117,1.117,0,0,1,7.6,12.3c-.264-.122-.881-.639-1.1-.648s-.865.528-1.126.648A1.116,1.116,0,0,1,3.73,11.61a5.733,5.733,0,0,0-.42-1c-.141-.106-.648-.062-.836-.075-.931-.063-1.557-.4-1.4-1.451A6.56,6.56,0,0,0,1.343,7.89C1.3,7.765.724,7.371.588,7.251a1.682,1.682,0,0,1-.582-.875M8.425,4.328a.6.6,0,0,0-.272.133L5.813,6.807c-.334-.282-.638-.71-.974-.976a.547.547,0,1,0-.76.787A13.447,13.447,0,0,0,5.434,7.973a.534.534,0,0,0,.734,0L8.959,5.167a.545.545,0,0,0-.534-.839",
    transform: "translate(6775 17418)",
    fill: "#014fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44582",
    "data-name": "Path 44582",
    d: "M120.369,127.793a.545.545,0,0,1,.534.839l-2.791,2.807a.534.534,0,0,1-.734,0,13.446,13.446,0,0,1-1.355-1.356.547.547,0,1,1,.76-.787c.335.266.639.695.974.976l2.34-2.346a.6.6,0,0,1,.272-.133",
    transform: "translate(6663.057 17294.533)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/blueTick.aab9264e7acf835935611d5b363224c7.svg";
export { ForwardRef as ReactComponent };